export const SEEK_THROTTLE_MS = 16;
export const DRAG_SETTLE_BACKSTOP_MS = 700;
export const PERCENTAGE_MULTIPLIER = 100;
export const CAP_WIDTH_PX = 12;
export const BOTH_CAPS_PX = CAP_WIDTH_PX * 2;
export const CLEAR_BUTTON_SIZE_PX = 16;
export const CLEAR_BUTTON_GAP_PX = 4;
export const CLEAR_BUTTON_CLEARANCE_PX = CLEAR_BUTTON_SIZE_PX + CLEAR_BUTTON_GAP_PX;
export const PLAYBACK_PROGRESS_MIN_WIDTH_PX = 2;
